import { render, staticRenderFns } from "./system_frend_link.vue?vue&type=template&id=15f46564&scoped=true&"
import script from "./system_frend_link.vue?vue&type=script&lang=js&"
export * from "./system_frend_link.vue?vue&type=script&lang=js&"
import style0 from "./system_frend_link.vue?vue&type=style&index=0&id=15f46564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f46564",
  null
  
)

export default component.exports